import React from 'react';
import SectionTitle from '../UI/SectionTitle/SectionTitle';
import classes from './Projects.module.scss';
import img from '../../assets/imgs/art-house/d-1.jpg';
import img2 from '../../assets/imgs/photography/photography_1.jpg';
import img3 from '../../assets/imgs/dotrun/dotrun_1.jpg';
import img4 from '../../assets/imgs/p-light/p-light_1.jpg';
import img5 from '../../assets/imgs/portfolio/p-1.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import Reveal from '../UI/Reveal/Reveal';
import BackgroundTitle from '../UI/BackgroundTitle/BackgroundTitle';

const works = [
  {
    img: img,
    name: 'Art House',
    details: 'This is a practice website. I have created this website with React. The design ideas are taken from google. I didn\'t use any third-party library to create the slider and other interaction effects.',
    tools: ['React', 'Javascript', 'Html', 'Sass', 'CSS'],
    liveLink: 'https://art-house-reactjs.netlify.app/'
  },
  {
    img: img2,
    name: 'Photography',
    details: 'This is a practice website. The design was inspired by prco.com. I created this website with React.',
    tools: ['React', 'Javascript', 'Html', 'Sass', 'CSS'],
    liveLink: 'https://photography-landing-reactjs.netlify.app/'
  },
  {
    img: img3,
    name: 'DotRun',
    details: 'This is a practice website. The Design ideas was create from google. I have created this website with React.',
    tools: ['React', 'Javascript', 'Html', 'Sass', 'CSS'],
    liveLink: 'https://dotrun-azher-reactjs.netlify.app/'
  },
  {
    img: img4,
    name: 'Portfolio Light',
    details: 'This is a practice website. I have created this website with React. The design ideas are taken from google.',
    tools: ['React', 'Javascript', 'Html', 'Sass', 'CSS'],
    liveLink: 'http://portfolio-landing-light.surge.sh/'
  },
  {
    img: img5,
    name: 'Portfolio Multi Page',
    details: 'This is a practice website. I have created this website with React. The design ideas are taken from google.',
    tools: ['React', 'Javascript', 'Html', 'Sass', 'CSS', 'Framer Motion'],
    liveLink: 'https://portfolio-animated-reactjs.netlify.app/'
  }
];

const Projects = ({ showAllProjectsHandler }) => {

  return (
    <div className={classes.Projects} style={{
      paddingBottom: works.length % 2 === 1 ? '5rem' : '10rem'
    }}>
      <BackgroundTitle parentClass={classes.Projects}>WORKS</BackgroundTitle>

      <div className={[classes.Container, 'container'].join(' ')}>

        <div className={classes.Head}>
          <SectionTitle>PROJECTS</SectionTitle>
        </div>

        <div className={classes.Contents}>

          {/* <Reveal fade offsetFraction={0.1}> */}
            {works.map((work, i) => {

              return (
                <div className={classes.Work} key={i} style={{
                  transform: i % 2 === 1 ? 'translateY(20%)' : 'none'
                }}>
                  <Reveal fade offsetFraction={0.1}>
                    <div className={classes.WorkCard}>
                      
                      <div className={classes.Preview}>
                        <img src={work.img} alt="IMG" className={classes.Image} />
                      </div>
                      
                      <div className={classes.Body}>
                        <h3 className={classes.Title}>{work.name}</h3>
                        {/* <p className={classes.Details}>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Assumenda blanditiis placeat repudiandae unde dolor corporis consequatur quos, beatae quibusdam a animi veniam dolores commodi? Veritatis labore totam eum? Eaque, totam!</p> */}
                        <p className={classes.Details}>{work.details}</p>
                        <div className={classes.Tools}>
                          {work.tools.map((tool, i)=> (
                            <p className={classes.Tool} key={i}>{tool}</p>
                          ))}
                        </div>
                        <hr className={classes.Hr}/>
                        <a href={work.liveLink} className={classes.LiveLink} target="_black">
                          <span className={classes.Icon}>
                            <FontAwesomeIcon icon={faLink} color="inherit" fontSize="inherit" />
                          </span>
                          Live Preview
                        </a>
                      </div>
                    
                    </div>
                  </Reveal>

                </div>
              );
            })}
          {/* </Reveal> */}

        </div>

        <div className={classes.showAllBtn}>
          <button className={classes.btn} onClick={showAllProjectsHandler}>Show All</button>
        </div>

      </div>
    </div>
  );
}

export default Projects;